export default __webpack_public_path__ + "static/media/X_invert.56453e83.svg";